import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TransportsListStateType } from 'src/types/transportsList';

const initialState: TransportsListStateType = {
    data: null,
    loading: false,
    error: false,
};
export const transportsListSlice = createSlice({
    name: 'transportsList',
    initialState,
    reducers: {
        getTransportsListFetch: (state, _action: PayloadAction<{ archive?: boolean } | undefined>) => {
            state.loading = true;
            state.error = false;
        },
        getTransportsListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getTransportsListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getTransportsListFetch,
    getTransportsListFetchSuccess,
    getTransportsListFetchFailure,
} = transportsListSlice.actions;

export default transportsListSlice.reducer;
